// extracted by mini-css-extract-plugin
export var deliveryRow = "_i1-a";
export var fixedHeight = "_i1-4";
export var freightLogo = "_i1-9";
export var fullWidth = "_i1-3";
export var priceColumn = "_i1-5";
export var radioSelected = "_i1-7";
export var radioUnselected = "_i1-6";
export var selectedOption = "_i1-2";
export var selectedOptionContainer = "_i1-1";
export var selection = "_i1-0";
export var tallSkeletonText = "_i1-8";